import api from '../../utils/api'
import { useState, useEffect, useMemo } from "react"
import { FiInbox } from 'react-icons/fi'

import Input from "../../shared/components/form/input"
import ListChecklistGroupRow from './ListRow/ListChecklistGroupRow'
import Modal from '../../shared/modal/Modal'
import NewChecklistGroup from './NewChecklistGroup'
import Button from '../../shared/components/Button/Button'
import useMyPermission from '../../hooks/useMyPermission'
import './ChecklistGroup.css'

function ChecklistGroup() {

    const [token] = useState(localStorage.getItem('token') || '')
    const [checklistGroups, setChecklistGroups] = useState([])
    const [modalNew, setModalNew] = useState(false)
    const [search, setSearch] = useState("")
    const [load, setLoad] = useState(false)
    const [myPermission, setMyPermission] = useState({ group: "" })

    const { checkPermission } = useMyPermission()
    const myPermissionView = checkPermission(myPermission, "checklistGroup_View")
    const myPermissionCreate = checkPermission(myPermission, "checklistGroup_Create")

    const getAll = () => {
        api.get(`/checklistGroup/getall`, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            if (response) {
                setChecklistGroups(response.data.checklistGroups)
                setMyPermission(response.data.permission)
                setLoad(true)
            }
        })
    }

    useEffect(() => { getAll() }, [token])

    async function handleReorder(reordered) {
        setChecklistGroups(reordered)
        const items = reordered.map((item, index) => ({ _id: item._id, order: index }))
        await api.patch('/checklistGroup/reorder', { items }, {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).catch(() => { getAll() })
    }

    const filter = useMemo(() => {
        const searchLowerCase = search.toLowerCase()
        return checklistGroups.filter((item) => (item.name || '').toLowerCase().includes(searchLowerCase))
    }, [checklistGroups, search])

    if (!load) {
        return <div className="pg-loading">Carregando grupos...</div>
    }

    if (!myPermissionView) {
        return (
            <div className="pg-empty">
                <p className="pg-empty-title">Sem permissão para visualizar grupos de checklist</p>
            </div>
        )
    }

    return (
        <section className="pg-page">

            <div className="pg-sticky-top">
                <div className="pg-header">
                    <div className="pg-header-title">
                        <p className="pg-title">Grupos de Checklist</p>
                        <span className="pg-title-accent" />
                    </div>
                    <div className="pg-header-row">
                        <div className="pg-header-actions">
                            {myPermissionCreate && <Button variant="new" onClick={() => setModalNew(true)}>Cadastrar</Button>}
                        </div>
                        <div className="pg-header-right">
                            <div className="pg-search">
                                <Input
                                    type="text"
                                    name="search"
                                    placeholder="Buscar grupo..."
                                    value={search}
                                    handleOnChange={(e) => setSearch(e.target.value)}
                                />
                            </div>
                            <span className="pg-count">
                                {filter.length} {filter.length === 1 ? 'grupo' : 'grupos'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="pg-list">
                {filter.length > 0 ? (
                    <ListChecklistGroupRow
                        dataArray={filter}
                        handleOnSuccess={getAll}
                        myPermission={myPermission}
                        onReorder={handleReorder}
                        dragEnabled={!search}
                    />
                ) : (
                    <div className="pg-empty">
                        <FiInbox size={32} className="pg-empty-icon" />
                        <p className="pg-empty-title">Nenhum grupo encontrado</p>
                        <p className="pg-empty-subtitle">
                            {checklistGroups.length === 0
                                ? 'Cadastre o primeiro grupo para começar.'
                                : 'Tente ajustar a busca.'}
                        </p>
                    </div>
                )}
            </div>

            <Modal
                modalStatus={modalNew}
                changeStatus={setModalNew}
                w={60}
                content={
                    <NewChecklistGroup
                        btCancelAction={() => setModalNew(false)}
                        handleOnSuccess={() => { setModalNew(false); getAll() }}
                    />
                }
            />

        </section>
    )
}

export default ChecklistGroup
